import { render, staticRenderFns } from "./AvenantObjectGroupManager.vue?vue&type=template&id=5f7b1118&scoped=true"
import script from "./AvenantObjectGroupManager.vue?vue&type=script&lang=ts"
export * from "./AvenantObjectGroupManager.vue?vue&type=script&lang=ts"
import style0 from "./AvenantObjectGroupManager.vue?vue&type=style&index=0&id=5f7b1118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b1118",
  null
  
)

export default component.exports